import script from "./FormView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormView.vue?vue&type=script&setup=true&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=0cbac686&lang=css"
import "./FormView.vue?vue&type=style&index=1&id=0cbac686&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cbac686"]])

export default __exports__